<div class="close-modal">
  <span class="cta" (click)="onClose()"><i class="fa fa-close"></i></span>
</div>
<div class="preview-document w-100" (click)="onClose()" [class.loaded]="state.attachmentLoaded">
  <iframe
    [src]="state.attachmentUrl"
    class="previewer"
    *ngIf="selectedAttachment && state.urlResolved"
    (load)="onAttachmentLoaded()"
    (click)="$event.stopPropagation()"
  ></iframe>
  <p
    class="default-paragraph loading p-4 text-center message"
    *ngIf="selectedAttachment"
    (click)="$event.stopPropagation()"
  >
    Loading attachment <strong>{{ selectedAttachment.filename }}</strong>
  </p>
  <p
    class="no-attachments p-4 text-center message"
    *ngIf="!selectedAttachment"
    (click)="$event.stopPropagation()"
  >
    No attachments are available.
  </p>
</div>
<div class="attachment-actions w-100 d-flex justify-content-end align-items-center">
  <div class="navigation-holder w-100 d-flex align-items-start justify-content-center">
    <ol class="navigation d-flex list-unstyled flex-nowrap justify-content-start m-0">
      <li
        *ngFor="let entry of attachments"
        class="p-0 mr-4 cta d-block"
        [class.current]="entry === selectedAttachment"
        [attr.title]="entry.filename"
        (click)="onChangeSelectedAttachment(entry)"
      >
        <img [attr.src]="entry.thumbnailUrl" class="thumbnail mr-2" />
      </li>
    </ol>
  </div>
  <div class="actions" [class.d-none]="!selectedAttachment">
    <span (click)="onDownloadSelectedAttachment()" class="mr-4 cta">
      <i class="fa fa-download" *ngIf="!downloading"></i>
      <i class="cc-icon cc-icon-spinner" *ngIf="downloading"></i>
    </span>
    <span (click)="onDeleteSelectedAttachment()" class="mr-4 cta delete-attachment" *ngIf="editable"
      ><i class="fa fa-trash"></i
    ></span>
  </div>
</div>
